export type AppTab = 'devices' | 'members' | 'help';

export const APP_TABS: { id: AppTab; label: string }[] = [
  { id: 'devices', label: 'Devices' },
  { id: 'members', label: 'Members & voices' },
  { id: 'help', label: 'Help' },
];

export interface Route {
  path: string;
  auth: boolean;
  tab?: AppTab;
}

export const ROUTES: Route[] = [
  { path: '/connect', auth: false },
  { path: '/setup', auth: false },
  { path: '/pair', auth: false },
  { path: '/wifi-setup', auth: false },
  { path: '/devices', auth: true, tab: 'devices' },
  { path: '/members', auth: true, tab: 'members' },
  { path: '/help', auth: true, tab: 'help' },
  /* Legacy aliases → new IA */
  { path: '/family', auth: true, tab: 'members' },
  { path: '/support', auth: true, tab: 'help' },
  { path: '/pictures', auth: true, tab: 'devices' },
  { path: '/', auth: true, tab: 'devices' },
];

export function matchRoute(pathname: string): Route {
  const exact = ROUTES.find((r) => r.path === pathname);
  if (exact) return exact;
  return ROUTES.find((r) => r.path === '/devices')!;
}

export function tabPath(tab: AppTab): string {
  return `/${tab}`;
}
